import { render, staticRenderFns } from "./ContractChangeAssets.vue?vue&type=template&id=a3ac7850&scoped=true"
import script from "./ContractChangeAssets.vue?vue&type=script&lang=js"
export * from "./ContractChangeAssets.vue?vue&type=script&lang=js"
import style0 from "./ContractChangeAssets.vue?vue&type=style&index=0&id=a3ac7850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ac7850",
  null
  
)

export default component.exports